import React from 'react'
import './ComFlex.css';
import { useTranslation } from 'react-i18next';
import Cardsolar from './Elements/Cardsolar';
import Cardsupply from './Elements/Cardsupply';
import Cardstorage from './Elements/Cardstorage';
import VideoLower from './Elements/VideoLower';
import i18n from 'i18next';

const ComFlex = () => {
    var lang = i18n.language;
  const { t } = useTranslation();

  document.title = t("page-title.comflex");

  return (
    <div className="UIComFlex">
      <div className="container-fluid background">
        <div className="bg-image">
          <VideoLower/>
        </div>
        <div className="container">
          <div className="heading">
            <h2>{t('tso.ngenponudba')}</h2>
            <h1>{t('pages.comflexbox')}</h1>
          </div>
        </div>
      </div>
      <div className="container hero-image">
        <img src={`${process.env.PUBLIC_URL + '/images/' + lang + "/rci-header-image.png"}`} alt={t('pages.com-flex')} className='starter-whatwedo' />
      </div>
      <div className="overlay">
        <img src={`${process.env.PUBLIC_URL}/images/w-overlay-tl.svg`} alt="" />
      </div>
      <div className="container content">
        <div className="text">
          <h4>{t('companies.heading2')}</h4>
          <p>{t('companies.text-3')}</p>
        </div>
      </div>
      <div className="container-fluid main">
      <div className="container cards">
        <div className="heading">
          <h4>{t('tso.ngenponudba')}</h4>
          <h3>{t('tso.lookat')}</h3>
        </div>
        <div className="row cards">
          <div className="col-sm-12 col-md-4 col-lg-4">
            <Cardstorage />
          </div>
          <div className="col-sm-12 col-md-4 col-lg-4">
            <Cardsolar />
          </div>
          <div className="col-sm-12 col-md-4 col-lg-4">
            <Cardsupply />
          </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default ComFlex